import ease from "ease-component";
import scroll from "scroll";

export default class BScroll
{
	static top(el, offset = 0)
	{
		scroll.top(document.querySelector('html'), el.getBoundingClientRect().top + window.scrollY + offset, {
			duration: 750,
			ease: ease.inOutSine,
		});
	}
}
